import React from 'react';

const ApprovalRouteList = ({ approvalRoute, sidebar }) => (
    <ul className='approval-route-list'>
        { approvalRoute.map(({ required, excluded, approver }, index) => required || !excluded ? (
            sidebar ? (
                <div className='text-pre-space m-b-15' key={index}>
                    <b>{approver.name}</b>
                </div>
            ) : (
                <li key={index}>{approver.name || approver.id}</li>
            )
        ) : null)}
    </ul>
);

export default ApprovalRouteList;
